import { render, staticRenderFns } from "./ProformaDate.vue?vue&type=template&id=56c4dcd8&"
import script from "./ProformaDate.vue?vue&type=script&lang=js&"
export * from "./ProformaDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports